import { Feature } from '@tencent/workbench';
import { SoftEdgeFeature } from '@framework/workbench/drawer/ui/effects/soft-edge/soft-edge-feature';
import { IChartSoftEdgeFeature } from './chart-soft-edge-interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import ChartShapeProperty from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { INPUT_PROPS_CALLBACK_KEY } from '@src/framework/workbench/drawer/constants';
import { handleInputBlurInitAndReset } from '@src/slide/application/service/drawer-input-manager/drawer-handler';
import type { NumberInputFrom } from '@tencent/wb-ext-form';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';

const defaultSoftEdgeProps = {
    size: 0,
};
const SOFT_EDGE_EMPTY = 'soft-0';

@Feature()
export class ChartSoftEdgeFeature extends SoftEdgeFeature implements IChartSoftEdgeFeature {
    public constructor() {
        super();
        this.addInitPropsCallback(INPUT_PROPS_CALLBACK_KEY.CHART_GLOBAL_SOFT_EDGE);
    }

    public getSelectModel(): any {
        const model = super.getSelectModel() as IChartModel;
        if (model?.type == UIModelType.CHART) {
            const chartSpace = model.getChartSpaceProperty() as ChartShapeProperty;
            if (!chartSpace) return model;
            return chartSpace;
        }
        return model;
    }

    public get softEdgeInfo() {
        return this.getSelectModel()?.getEffect?.()
            .getSoftEdge() ?? defaultSoftEdgeProps;
    }

    public updateSoftEdgeProps = (onlyChangeUI?: boolean, onPreview?: boolean) => {
        if (onlyChangeUI) return;
        const selectedModel = this.getSelectModel();
        selectedModel.updateEffect({ softEdge: { ...this.softEdgeProps } });
    };

    public handleSoftEdgePresetStyleClick = (softEdge) => {
        this.getAppService().editableServiceLayer?.previewService?.updateElementPreviewState(false);
        this.softEdgeProps = { ...defaultSoftEdgeProps, ...softEdge };
        this.updateSoftEdgeProps();
        this.tdwDrawerReport(ChartFormItemKey.CHART_GLOBAL_SOFT_EDGE, { ver5: softEdge ? 2 : 1 });
    };

    @handleInputBlurInitAndReset(INPUT_PROPS_CALLBACK_KEY.CHART_GLOBAL_SOFT_EDGE)
    public handleSoftEdgeChange(value, dragEnd?: boolean, from?: NumberInputFrom) {
        this.softEdgeProps = { ...this.softEdgeInfo, ...value };
        const onlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        this.updateSoftEdgeProps(onlyChangeUI);
        this.tdwDrawerReportNumberInput(
            ChartFormItemKey.CHART_GLOBAL_SOFT_EDGE_SIZE,
            { ver6: value.size }, from, onlyChangeUI,
        );
    }
}
